
<template>
  <div class="loan_box">
    <div class="pro_item">
      <h1 class="h1"><span class="line"></span> {{orderTitleJson.title}} </h1><span class="info">申请多个产品可提高通过率</span>
    </div>
    <div class="loan_list">
      <div class="item"
           v-for="(item,index) in orderList"
           :key="index"
           @click="toProductDetail(item.pageUrl)">
        <img class="icon_img"
             :src="item.productIcon"
             alt="">
        <div class="flc">
          <p class="name">{{item.title}}</p>
          <p class="money">{{item.productMoney}}</p>
        </div>
        <p class="rate">通过率{{getRandomNumberByRange(96,99)}}%</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['orderList', 'orderTitleJson'],
  data () {
    return {
      orderId: '',
      // orderList: [],
      bigList: [],
    }
  },
  components: {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    getRandomNumberByRange (start, end) {
      return Math.floor(Math.random() * (end - start) + start)
    },
    //调用android和ios的方法
    toProductDetail (pageUrl) {
      let param = {
        pageUrl: pageUrl
      }
      if (pageUrl.indexOf("http") == "-1") {
        //跳到客户端页面——产品详情页面
        try {
          window.webkit.messageHandlers.toProductDetail.postMessage(param);//ios
        } catch (err) {
          window.AppJs.toProductDetail(JSON.stringify(param));//android
        }
      } else {
        window.location.href = pageUrl;
      }
    },
  }
}
</script>
<style scoped>
.loan_box {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0.15rem;
  margin-top: 0.1rem;
}
.h1 {
  font-size: 0.14rem;
  color: #333;
}
.h1 span {
  font-size: 0.12rem;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.loan_list {
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.15rem;
  padding-top: 0.15rem;
}
.icon_img {
  width: 0.45rem;
  height: 0.45rem;
  background: #ccc;
}
.name {
  color: #333;
  font-size: 0.16rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}
.money {
  color: #ee6c67;
  font-size: 0.16rem;
  position: relative;
  top: 0.02rem;
  font-family: DINAlternate-Bold;
}
.rate {
  color: #ee6c67;
  font-size: 0.12rem;
  position: relative;
  top: 0.15rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
.flc {
  flex: 0.9;
}
.info {
  color: #999;
  font-size: 0.11rem;
  float: right;
}
.pro_item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.15rem;
}
</style>